module.exports = __webpack_public_path__ + "img/calendar.11c6034f.gif";